import { mapMutations, mapGetters } from 'vuex'
import { GENERAL_STORE } from '../store'

export default {
  props: {
    dot: Object,
  },
  computed: {
    ...mapGetters(GENERAL_STORE, ['getDotIndex']),
    contact: {
      get() {
        return this.dot.contact
      },
      set(value) {
        this.updateDot({ dot: this.dot, data: { key: 'contact', value } })
      },
    },
    comment: {
      get() {
        return this.dot.comment
      },
      set(value) {
        this.updateDot({ dot: this.dot, data: { key: 'comment', value } })
      },
    },
  },
  methods: {
    ...mapMutations(GENERAL_STORE, ['updateDot']),
    enter(el) {
      const { width } = getComputedStyle(el)

      el.style.width = width
      el.style.position = 'absolute'
      el.style.visibility = 'hidden'
      el.style.height = 'auto'

      const { height } = getComputedStyle(el)

      el.style.width = null
      el.style.position = null
      el.style.visibility = null
      el.style.height = 0

      getComputedStyle(el).height

      requestAnimationFrame(() => {
        el.style.height = height
      })
    },
    afterEnter(el) {
      el.style.height = 'auto'
    },
    leave(el) {
      const { height } = getComputedStyle(el)

      el.style.height = height

      getComputedStyle(el).height

      requestAnimationFrame(() => {
        el.style.height = 0
      })
    },
    removeComment() {
      this.comment = ''
    },
  },
}
